import { Slider } from "@/components";
import { Button } from "@/components/ui";
import { Link } from "react-router-dom";

// helper to render ™ and ® as superscript
function formatTitle(title: string) {
  return title.split(/(™|®)/g).map((part, index) => {
    if (part === "™" || part === "®") {
      return (
        <sup key={index} className="text-xs align-super ml-[1px]">
          {part}
        </sup>
      );
    }
    return <span key={index}>{part}</span>;
  });
}

const ProductSlider = ({ slides }: { slides: any }) => {
  return (
    <Slider
      hideDots
      autoSlide
      slides={slides.map((data: any) => (   // 👈 only 3 products
        <div
          key={data.id || data.title}
          className="w-full flex-shrink-0 px-4 sm:px-6 lg:px-[50px] mb-15 mt-10"
        >
          <div className="grid relative mt-6 lg:mt-10 lg:ml-10">
            {/* Decorative border box (hidden on mobile) */}
            <div className="hidden lg:block lg:h-[400px] lg:w-[850px] border-[7px] rounded-[40px] border-blue-50 absolute -z-1 -top-8 -left-8" />

            {/* Card container */}
            {/* Card container */}
            <div className="bg-white rounded-[20px] sm:rounded-[25px] lg:rounded-[30px] overflow-hidden grid grid-cols-1 lg:grid-cols-2 
               h-[600px] sm:h-auto lg:h-[400px] shadow-md">

              
              {/* Left side: Product image */}
              <div className="flex items-center justify-center bg-gray-50">
                <img
                  src={data.img}
                  alt={data.name}
                  className="object-contain max-h-[300px]"
                />
              </div>

              {/* Right side: Logo + Know More */}
              <div className="flex flex-col items-start justify-center p-6">
                <img
                  src={data.imglogo}
                  alt={`${data.name} logo`}
                  className="object-contain"
                />
                <Link to={`/our-products?product=${encodeURIComponent(data.name || data.title)}`} className="mt-6">
                  <Button size="sm" className="sm:size-md">
                    Know More
                  </Button>
                </Link>
              </div>

            </div>
          </div>
        </div>
      ))}
    />
  );
};

export default ProductSlider;
